import React from 'react';
import { Truck, Check } from 'lucide-react';
import { Badge, CountBadge } from '@ajat/design-system/Badge';
import { ComponentPage, DemoCard, DemoRow, Demo } from '../../shared';

export const meta = {
  title: 'Badge',
  group: 'Data display',
  importPath: '@ajat/design-system/Badge',
  description:
    'Short status and category tags — an order status pill, a patch type chip, a promo tag — on the DS ui colour pairs, plus CountBadge: the number beside a row\'s label.',
  propSets: [
    {
      title: 'Badge',
      component: Badge,
      componentName: 'Badge',
      rows: [
        ['variant', "'neutral' | 'brand' | 'success' | 'warning' | 'error' | 'info'", "'neutral'", 'Colour pair — gray, brand (gray-075 + the brand alternative primary: the promo chip over a photo) or a DS ui tone with its background'],
        ['size', "'s' | 'm' | 'l'", "'m'", 's: a chip (small-s padding) · m: a pill (small-m) · l: a tag at H6'],
        ['shape', "'pill' | 'square'", "'pill'", 'pill: the brand --radius-button (a full pill on Overall, a 2px tag on CLS) · square: --radius-inner-radius (an element inside a card)'],
        ['icon', 'node', '—', 'Leading icon, 14–16px'],
        ['className', 'string', "''", 'Additional CSS class'],
        ['children', 'node', '—', 'The text'],
      ],
    },
    {
      title: 'CountBadge',
      component: CountBadge,
      componentName: 'CountBadge',
      rows: [
        ['value', 'number', '—', 'The count'],
        ['max', 'number', '99', 'Values above render as "max+"'],
        ['hideZero', 'bool', 'true', 'Render nothing at 0'],
        ['className', 'string', "''", 'Additional CSS class'],
      ],
    },
  ],
  usage: [
    {
      title: 'Order status and a type chip',
      code: `import { Badge, CountBadge } from '@ajat/design-system/Badge';

<Badge variant="success" icon={<Check size={14} />}>Levererad</Badge>
<Badge size="s">Vanlig patch</Badge>
<Badge size="l" shape="square" variant="success">10% RABAT</Badge>
<Badge size="l" shape="square" variant="brand">Gratis</Badge>   // the chip over a ContentBannerV4 photo

// beside a row label
Sparade designer <CountBadge value={4} />`,
    },
  ],
};

export default function BadgePage() {
  return (
    <ComponentPage meta={meta}>
      <DemoCard title="Variants" hint="size m, pill">
        <DemoRow align="center">
          <Badge>Neutral</Badge>
          <Badge variant="success" icon={<Check size={14} strokeWidth={2} />}>Levererad</Badge>
          <Badge variant="warning" icon={<Truck size={14} strokeWidth={2} />}>På väg</Badge>
          <Badge variant="error">Avbruten</Badge>
          <Badge variant="info">Info</Badge>
          <Badge variant="brand">Brand</Badge>
        </DemoRow>
      </DemoCard>
      <DemoCard title="Sizes and shapes">
        <DemoRow align="center">
          <Demo caption="S · CHIP"><Badge size="s">Vanlig patch</Badge></Demo>
          <Demo caption="M · PILL"><Badge size="m">Textpatch</Badge></Demo>
          <Demo caption="L · SQUARE"><Badge size="l" shape="square" variant="success">10% RABAT</Badge></Demo>
          <Demo caption="L · SQUARE · BRAND"><Badge size="l" shape="square" variant="brand">Gratis</Badge></Demo>
        </DemoRow>
      </DemoCard>
      <DemoCard title="CountBadge" hint="hidden at 0, capped at max">
        <DemoRow align="center">
          <Demo caption="4"><CountBadge value={4} /></Demo>
          <Demo caption="12"><CountBadge value={12} /></Demo>
          <Demo caption="120 (max 99)"><CountBadge value={120} /></Demo>
          <Demo caption="0 · hideZero={false}"><CountBadge value={0} hideZero={false} /></Demo>
        </DemoRow>
      </DemoCard>
    </ComponentPage>
  );
}
